import { minLength, object, string, regex } from "valibot";

export type RecoveryFormShapeT = {
  user: string;
};

const RUT_REGEXP = /^(?:1\d{2}\.\d{3}|[2-9]\d{2}\.\d{3}|\d{1,3}(?:\.\d{3}){2,})-[\dkK]$/;
const MIN_LENGTH_VALIDATION = minLength<string, number>(1, "FORM.INPUTS.USER.ERROR");

export const RECOVERY_SCHEMA = object({
  user: string([regex(RUT_REGEXP, "FORM.INPUTS.USER.ERROR"), MIN_LENGTH_VALIDATION]),
});
